"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _MD = _interopRequireDefault(require("../Icons/Cross/MD"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["children", "classes", "className", "disableTypography", "onClose", "closeButtonVariant"];
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    spacing
  } = theme.busbud;
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      margin: 0,
      padding: spacing(2, 3.5),
      flex: '0 0 auto'
    },
    withTitle: {
      padding: spacing(3, 3.5),
      minHeight: spacing(8)
    },
    closeable: {
      paddingRight: spacing(6.5)
    },
    closeIcon: {
      position: 'absolute',
      top: spacing(2.5),
      right: spacing(2.5),
      cursor: 'pointer',
      zIndex: 2 // fix for iPhones
    }
  };
});
/**
 * DialogTitle is a wrapper used to style the title inside a `Dialog` component.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-dialogtitle--page)
 */
const DialogTitle = /*#__PURE__*/_react.default.forwardRef(function DialogTitle(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      disableTypography = false,
      onClose,
      closeButtonVariant = 'contained'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, className, {
      [classes.closeable]: !!onClose,
      [classes.withTitle]: !!children
    }),
    ref: ref
  }, other), disableTypography ? children : /*#__PURE__*/_react.default.createElement(_Heading.default, {
    component: "h2",
    size: "xs",
    fontWeight: "bold"
  }, children), onClose ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: classes.closeIcon,
    onClick: onClose,
    tabIndex: 0,
    "aria-labelledby": "close"
    // eslint-disable-next-line jsx-a11y/aria-role -- TODO: [fix-jsx-a11y]
    ,
    role: "close",
    color: "tertiary",
    size: "sm",
    variant: closeButtonVariant
  }, /*#__PURE__*/_react.default.createElement(_MD.default, {
    display: "block",
    color: "icon.primary.opaque"
  })) : null);
});
var _default = exports.default = DialogTitle;